import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bs5-tab-panel',
  templateUrl: './bs5-tab-panel.component.html',
  styleUrls: ['./bs5-tab-panel.component.scss'],
  host: {
  },
  standalone: true
})
export class Bs5TabPanelComponent implements OnInit {

  @Input('panelTitle') panelTitle!: string;
  @Input('disabled') disabled = false;
  // @Input('selectedClass') selectedClass!: string;

  // '[class.bs5-tab-panel]': 'true'

  @Input('panelCustomClass') panelCustomClass!: string;

  @HostBinding('class.active') selected = false;
  @HostBinding('class.hidden') get hiddenClass() {
    return !this.selected;
  }

  // @HostBinding('class')
  // get hostClasses(): string {
  //   // let classes = ''; // 기본 클래스
  //   // if (this.selected && this.selectedClass) {
  //   //   classes += ` ${this.selectedClass}`; // 조건에 따라 클래스 추가
  //   // }
  //   // return classes;
  //   return this.selectedClass;
  // }

  constructor() { }

  ngOnInit(): void {
  }

}
